import { buildDongwuSandEntries } from '@/config/dongwuManifest'

/** 动物沙具（static/models/dongwu）— 列表见 dongwuManifest.js */
export const DONGWU_SAND_ENTRIES = buildDongwuSandEntries()



// WEBPACK FOOTER //
// ./src/config/dongwuAnimals.js